module.exports = __webpack_public_path__ + "avatar.png?aa1173a912b80261166e19f1efdfb354";


//////////////////
// WEBPACK FOOTER
// ./statics/img/avatar.png
// module id = 21
// module chunks = 20